import gql from 'graphql-tag';
const MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT = gql `
  fragment MyChoiceKeyboardingActivityFragment on MyChoiceKeyboardingActivity {
    rounds {
      roundIndex
      steps {
        stepIndex
        type
        questionType
        optionalQuestion: question
        optionalAudio: audio
        optionalImage: image
        instructions
        instructionsAudio
      }
    }
  }
`;
export default MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT;
